<script>
import {
  GlFilteredSearchToken,
  GlAvatar,
  GlFilteredSearchSuggestion,
  GlDropdownDivider,
  GlLoadingIcon,
} from '@gitlab/ui';
import { debounce } from 'lodash-es';
import Api from '~/api';
import { createAlert } from '~/alert';
import { __ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { ANY_TRIGGER_AUTHOR, FILTER_PIPELINES_SEARCH_DELAY } from '../constants';

export default {
  name: 'PipelineTriggerAuthorToken',
  anyTriggerAuthor: ANY_TRIGGER_AUTHOR,
  components: {
    GlFilteredSearchToken,
    GlAvatar,
    GlFilteredSearchSuggestion,
    GlDropdownDivider,
    GlLoadingIcon,
  },
  mixins: [glListenersMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      users: [],
      loading: true,
    };
  },
  computed: {
    currentValue() {
      return this.value.data.toLowerCase();
    },
    activeUser() {
      return this.users.find((user) => {
        return user.username.toLowerCase() === this.currentValue;
      });
    },
  },
  created() {
    this.fetchProjectUsers();
  },
  methods: {
    fetchProjectUsers(searchTerm) {
      Api.projectUsers(this.config.projectId, searchTerm)
        .then((users) => {
          this.users = users;
          this.loading = false;
        })
        .catch((err) => {
          createAlert({
            message: __('There was a problem fetching project users.'),
          });
          this.loading = false;
          throw err;
        });
    },
    searchAuthors: debounce(function debounceSearch({ data }) {
      this.fetchProjectUsers(data);
    }, FILTER_PIPELINES_SEARCH_DELAY),
  },
};
</script>

<template>
  <gl-filtered-search-token
    :config="config"
    v-bind="{ ...$props, ...$attrs }"
    v-on="glListeners()"
    @input="searchAuthors"
  >
    <template #view="{ inputValue }">
      <gl-avatar v-if="activeUser" :size="16" :src="activeUser.avatar_url" class="gl-mr-2" />
      <span>{{ activeUser ? activeUser.name : inputValue }}</span>
    </template>
    <template #suggestions>
      <gl-filtered-search-suggestion :value="$options.anyTriggerAuthor">{{
        $options.anyTriggerAuthor
      }}</gl-filtered-search-suggestion>
      <gl-dropdown-divider />

      <gl-loading-icon v-if="loading" size="sm" />
      <template v-else>
        <gl-filtered-search-suggestion
          v-for="user in users"
          :key="user.username"
          :value="user.username"
        >
          <div class="gl-flex">
            <gl-avatar :size="32" :src="user.avatar_url" />
            <div>
              <div>{{ user.name }}</div>
              <div>@{{ user.username }}</div>
            </div>
          </div>
        </gl-filtered-search-suggestion>
      </template>
    </template>
  </gl-filtered-search-token>
</template>
